<template>
  <base-section id="theme-features">
    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="4"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'FINANCIAL STATEMENTS',
          icon: 'mdi-finance',
          text: 'We assist in the preparation of financial statements for your submissions or for internal management.',
        },
        {
          title: 'ACCOUNTING',
          icon: 'mdi-fountain-pen-tip',
          text: 'We prepare and maintain your books and records in accordance to statutory regulations, as well as prepare and file timely all required reports for your submissions.',
        },
        {
          title: 'PAYROLL',
          icon: 'mdi-currency-usd',
          text: 'As your team grows, we will assist in your payroll processes so that you can grow your business and train your team.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: 'CORPORATE TAX',
          icon: 'mdi-cellphone',
          text: 'We assist in the preparation of corporate tax for your submissions.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: 'PERSONAL TAX',
          icon: 'mdi-pencil-box-outline',
          text: 'We assist in the preparation of personal tax for your submissions.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
          text: '',
        },
        {
          title: 'Business Registration',
          icon: 'mdi-handshake',
          text: 'Our team of business registration consultants have helped set up legal entities for founders, entrepreneurs and conglomerates.',
        },
        {
          title: 'Trademark',
          icon: 'mdi-trademark',
          text: 'We assist to file your trademark and protect your assets. We manage the entire process from Filing to Registration. Legally protect your company’s name and logo, so that no one else can claim it.',
        },
        {
          title: 'Flexible Legal Consulting',
          icon: 'mdi-align-vertical-center',
          text: 'Our partnered Lawyers understand the challenges you face. Whether you need to create legal documents for your business, or need help staying compliant, we’re here to help your business grow.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: 'Shareholder Agreements',
          icon: 'mdi-export-variant',
          text: 'Avoid potential disputes and set up your business by making sure all the shareholders agree on the details. Greater protection to shareholders over and above the standard articles of association, in terms of how the company is run, decision making, minority shareholder and majority shareholder rights.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: 'Contract Review',
          icon: 'mdi-file-document-edit',
          text: 'Ensure fair representation on all legal contracts you sign. Whether you need help drafting the right deal or advice on whether you should sign, our legal team will help you guide and navigate the most important decisions along your business journey. ',
        },
      ],
    }),
  }
</script>
